// extracted by mini-css-extract-plugin
export default {"loading":"_2lUY","error":"bzzc","result":"_2X1W","panelSize":"VMMc","internalPanelSize":"_2azF","description":"dY2A","pagination":"nqve","tableCell":"znD9","panelContainer":"vTYy"};